import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import "./SummaryAndPlanSection.css";

const getSummaryValues = (record) => {
  const description = String(record?.description || "");
  if (!description) return { diagnosis: "", summary: "", plan: "" };
  try {
    const values = JSON.parse(description);
    if (values && typeof values === "object") {
      return {
        diagnosis: String(values.diagnosis || ""),
        summary: String(values.summary || ""),
        plan: String(values.plan || ""),
      };
    }
  } catch {
    return { diagnosis: "", summary: description, plan: "" };
  }
  return { diagnosis: "", summary: description, plan: "" };
};

export default function SummaryAndPlanSection({ summaryRecord, summaryLoading, summaryError }) {
  const { t } = useTranslation("neurologue");
  const [diagnosis, setDiagnosis] = useState("");
  const [summary, setSummary] = useState("");
  const [plan, setPlan] = useState("");
  const [summaryDictation, setSummaryDictation] = useState(false);
  const [planDictation, setPlanDictation] = useState(false);

  useEffect(() => {
    const values = getSummaryValues(summaryRecord);
    setDiagnosis(values.diagnosis);
    setSummary(values.summary);
    setPlan(values.plan);
  }, [summaryRecord]);

  return (
    <section
      className="neurologue-section-card summary-plan"
      data-summary-record-id={summaryRecord?.id || ""}
    >
      {summaryLoading && <p role="status">{t("common.loading", { defaultValue: "Loading…" })}</p>}
      {summaryError && <p role="alert">{summaryError}</p>}
      <label className="summary-plan__diagnosis">
        <span>{t("summary.diagnosis")}</span>
        <textarea value={diagnosis} onChange={(event) => setDiagnosis(event.target.value)} placeholder={t("summary.diagnosisPlaceholder")} />
      </label>

      <div className="summary-plan__panel summary-plan__panel--summary">
        <div className="summary-plan__panel-header">
          <h3>{t("summary.total")}</h3>
          <div className="summary-plan__actions">
            <button type="button" className="summary-plan__draft" onClick={() => setSummary(t("summary.summaryDraft"))}>{t("summary.autoDraftData")}</button>
            <span>{t("summary.autoDictate")}</span>
            <button
              type="button"
              role="switch"
              aria-label={t("summary.toggleSummary")}
              aria-checked={summaryDictation}
              className={`summary-plan__switch${summaryDictation ? " is-on" : ""}`}
              onClick={() => setSummaryDictation((enabled) => !enabled)}
            ><i /></button>
            <button type="button" className="summary-plan__mic" aria-label={t("summary.startSummary")}>Mic</button>
          </div>
        </div>
        <textarea value={summary} onChange={(event) => setSummary(event.target.value)} placeholder={t("summary.summaryPlaceholder")} />
      </div>

      <div className="summary-plan__panel summary-plan__panel--plan">
        <div className="summary-plan__panel-header">
          <h3>{t("summary.planTitle")}</h3>
          <div className="summary-plan__actions">
            <button type="button" className="summary-plan__draft summary-plan__draft--green" onClick={() => setPlan(t("summary.planDraft"))}>{t("summary.autoDraftPlan")}</button>
            <span>{t("summary.autoDictate")}</span>
            <button
              type="button"
              role="switch"
              aria-label={t("summary.togglePlan")}
              aria-checked={planDictation}
              className={`summary-plan__switch${planDictation ? " is-on" : ""}`}
              onClick={() => setPlanDictation((enabled) => !enabled)}
            ><i /></button>
            <button type="button" className="summary-plan__mic" aria-label={t("summary.startPlan")}>Mic</button>
          </div>
        </div>
        <textarea value={plan} onChange={(event) => setPlan(event.target.value)} placeholder={t("summary.planPlaceholder")} />
      </div>

    </section>
  );
}
